<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='550px' center
             @close='dialogClose' :close-on-click-modal='false'>
    <el-form ref='ruleForm' class='dialogForm' :model='form' label-width='95px' :rules='rules'>
      <el-form-item label='角色名称：' prop='roleName'>
        <el-input :style="'width:100%'"
                  v-model='form.roleName'
                  placeholder='请输入角色名称'
                  autocomplete='off'
                  size='small' />
      </el-form-item>
      <el-form-item label='描述：' prop='explaind'>
        <el-input type='textarea'
                  :autosize='{ minRows: 2, maxRows: 6}'
                  v-model='form.explaind'
                  placeholder='请输入描述'
                  size='small' />
      </el-form-item>
      <div class='btnContainer mt20'>
        <el-button size='small' class='searchBtn' :loading='buttonLoading' @click='dialogSubmit'>
          {{ dialogTitle === '新增角色' ? '新增' : '修改' }}
        </el-button>
        <el-button size='small' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { addAppRole, updateAppRole } from '@/service/basicfile';

  export default {
    leader: 'role-new',
    data() {
      return {
        dialogTitle: '',
        dialogVisible: false,
        buttonLoading: false,
        defaultForm: {},
        form: {
          roleName: '',
          explaind: '',
        },
        rules: {
          roleName: [
            {
              required: true,
              message: '请输入部门角色名称',
              trigger: 'blur',
            },
          ],
        },
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(title, item) {
        this.dialogTitle = title;
        if (item) this.form = JSON.parse(JSON.stringify(item));
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.clearValidate();
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      },
      dialogSubmit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.buttonLoading = true;
            const res = this.dialogTitle === '新增角色' ? await addAppRole(this.form) : await updateAppRole(this.form);
            this.buttonLoading = false;
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.dialogClose();
            this.$emit('success');
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>
